import { useNavigate, useParams,useLocation } from "react-router-dom";

export const withRouter = (WrappedComponent) => (props) => {
  const params = useParams();
  const navigate = useNavigate();
  let location = useLocation();
  return <WrappedComponent {...props} location={location}params={params} navigate={navigate} />;
};